/**
 * 模块化配置路由的示例
 */
import Layout from "@/Layout/LayoutEmpty.vue";

const errorPagesRouter = {
  path: "/error",
  component: Layout,
  hideen: true,
  children: [
    {
      path: "401",
      name: "401",
      meta: { title: "401", icon: "icon-jieshao", auth: "developer" },
      component: () => import("@/Views/Error/401.vue"),
    },
    {
      path: "403",
      name: "403",
      meta: { title: "403", icon: "icon-jieshao", auth: "developer" },
      component: () => import("@/Views/Error/403.vue"),
    },
    {
      path: "404",
      name: "404",
      meta: { title: "404", icon: "icon-jieshao" },
      component: () => import("@/Views/Error/404.vue"),
    },
    {
      path: '/noAuth',
      name: 'noAuth',
      meta: { title: 'noAuth', icon: 'icon-jieshao' },
      component: () => import('./../../Views/Error/noAuth')
    }
  ],
};

export default errorPagesRouter;
